import { mat3, vec2, vec3 } from 'gl-matrix';
import * as ext from './ext';
export { mat3, vec2, vec3, ext };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/matrix-util/esm/index.js
// module id = null
// module chunks = 